import toString from "lodash/toString"

/**
 * Takes a month and a year, and returns a string with the month and year
 * formatted as MM/YYYY
 *
 * @function
 * @param {number} month - The month of the expiration date.
 * @param {number} year - The year of the card's expiration date.
 * @returns {string} A string with the month and year in the format MM/YYYY.
 */
export const getFormattedExpirationDate = (month, year) => {
  let finalMonth = month

  if (toString(finalMonth).length === 1) {
    finalMonth = `0${month}`
  }

  return `${finalMonth}/${year}`
}
